export const querify = (obj: { [key: string]: any }, valueDivider = '=', paramsJoiningSign = '&'): string => {
  return Object.keys(obj).map((k: string) => `${k}${valueDivider}${obj[k]}`).join(paramsJoiningSign);
}